<template>
  <footer v-if="!loading" class="hotsite-footer" :class="{ 'hotsite-footer-spaced': isRegister }">
    <div
      v-if="getSocialMedia.length || (getWhatsapp && getWhatsapp.link)"
      class="social-networks"
      :style="{ backgroundColor: getAssets.colors.socialNetworksFooter.background, color: getAssets.colors.socialNetworksFooter.font }"
    >
      <i v-if="getWhatsapp && getWhatsapp.link" class="fab fa-whatsapp" @click="redirect(getWhatsapp.link)"></i>
      <i v-for="media in getSocialMedia" :key="media[0]" :class="`fab fa-${media[0]}`" @click="redirect(media[1])"></i>
    </div>
    <div class="cookies-links" :style="{ backgroundColor: getAssets.colors.legalFooter.background, color: getAssets.colors.legalFooter.font }">
      <p v-if="!isKoch" @click="termosDialog = true">Termos de aceite do clube</p>
      <cookies-banner-modal activator="cookies" :accept-terms.sync="acceptTerms" @close="close" />
      <a v-for="(link, index) in hotsiteLinks" :key="index" :href="link.url" :style="{ color: getAssets.colors.legalFooter.font }" target="_blank">
        {{ link.name }}
      </a>
    </div>

    <termo-adesao v-if="termosDialog" hide-buttons :dialog.sync="termosDialog" dont-show-arrow>
      <span v-html="getTerms"></span>
    </termo-adesao>
  </footer>
</template>

<script>
import marked from 'marked'
export default {
  components: {
    TermoAdesao: () => import('@/components/modals/TermoAdesao'),
    CookiesBannerModal: () => import('@/components/modals/CookiesBannerModal.vue')
  },
  data() {
    return {
      termosDialog: false,
      acceptTerms: false
    }
  },
  computed: {
    isKoch() {
      const { hostname } = location
      return hostname === 'koch.querovantagens.com'
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    getSocialMedia() {
      const socialMedia = Object.entries(this.$store.getters.SOCIAL_MEDIA)
      return socialMedia.filter(media => media[1] && media[0] !== 'whatsapp')
    },
    getWhatsapp() {
      return this.$store.getters.SOCIAL_MEDIA.whatsapp ? this.$store.getters.SOCIAL_MEDIA.whatsapp.find(number => number.show_in_hotsite) : {}
    },
    getTerms() {
      const content = this.$store.getters.GET_TERMS.content
      return content ? marked(content) : ''
    },
    loading() {
      return this.$store.getters.LOADING
    },
    isRegister() {
      return this.$route.name === 'cadastro'
    },
    hasPixel() {
      return !!this.$store.getters.PIXEL
    },
    hasGA() {
      return !!this.$store.getters.GOOGLE_ANALYTICS
    },
    hotsiteLinks() {
      return this.$store.state.hotsiteLinks
    }
  },
  methods: {
    redirect(link) {
      window.open(link, '_blank')
    },
    close(acceptTerms) {
      this.acceptTerms = acceptTerms
      localStorage.setItem('pixelCookiePermission', acceptTerms)
      localStorage.setItem('googleAnalyticsCookiePermission', acceptTerms)
      this.$emit('close', this.acceptTerms)
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;

.hotsite-footer-spaced {
  margin-top: 60px;
}
.hotsite-footer {
  & .social-networks {
    padding: 20px 0;
    text-align: center;

    & i {
      font-size: 28px;
      margin: 0 15px;
      cursor: pointer;
    }
  }

  & .cookies-links {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    flex-wrap: wrap;
    gap: 16px;

    & p,
    & a {
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      font-weight: 500;
      opacity: 0.7;
      letter-spacing: 0.04em;
      display: inline-block;
      cursor: pointer;
      text-decoration: none;
      margin: 0 !important;
    }
  }
}

@media screen and (max-width: $phone-size) {
  .hotsite-footer {
    & .cookies-links {
      display: block;
      text-align: center;
      & p {
        display: block;
        margin: 8px 0 !important;
        &:nth-child(1) {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
